/**
 * Hook para Navegação entre Steps do Formulário
 */

import { useMemo } from 'react';
import { useFormContext } from '../context';
import { STEP_ORDER } from '../constants';

export interface UseFormStepReturn {
  currentStepIndex: number;
  currentStepId: string;
  nextStepId?: string;
  previousStepId?: string;
  nextStep: () => void;
  previousStep: () => void;
  goToStep: (stepId: string) => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  progress: number;
  totalSteps: number;
}

export const useFormStep = (): UseFormStepReturn => {
  const { currentStepIndex, currentStepId, goToNextStep, goToPreviousStep, goToStep } = useFormContext();

  const nextStepId = useMemo(() => {
    return STEP_ORDER[currentStepIndex + 1];
  }, [currentStepIndex]);

  const previousStepId = useMemo(() => {
    return STEP_ORDER[currentStepIndex - 1];
  }, [currentStepIndex]);

  const isFirstStep = currentStepIndex === 0;
  const isLastStep = currentStepIndex === STEP_ORDER.length - 1;
  const progress = Math.round(((currentStepIndex + 1) / STEP_ORDER.length) * 100);
  const totalSteps = STEP_ORDER.length;

  const nextStep = () => goToNextStep();
  const previousStep = () => goToPreviousStep();

  return {
    currentStepIndex,
    currentStepId,
    nextStepId,
    previousStepId,
    nextStep,
    previousStep,
    goToStep,
    isFirstStep,
    isLastStep,
    progress,
    totalSteps,
  };
};
